import { JSX, useCallback, useState } from "react";

import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";

export type ExpandableProps = {
	title: React.ReactNode;
	adornment?: React.ReactNode;
	children?: React.ReactNode;
};

export default function Expandable(
	props: Readonly<ExpandableProps>
): JSX.Element {
	const [open, setOpen] = useState(false);

	const toggleOpen = useCallback(() => {
		setOpen(previous => !previous);
	}, []);

	return (
		<>
			<Grid container alignItems="center">
				<Grid item>
					<IconButton
						size="small"
						onClick={toggleOpen}
						aria-label="toggle-expansion">
						{open ? (
							<KeyboardArrowUpIcon />
						) : (
							<KeyboardArrowDownIcon />
						)}
					</IconButton>
				</Grid>
				<Grid item>{props.title}</Grid>
				{props.adornment && <Grid item>{props.adornment}</Grid>}
			</Grid>
			<Collapse in={open}>
				<Box sx={{ marginLeft: 1 }}>{props.children}</Box>
			</Collapse>
		</>
	);
}
